import React, { useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function AddPropertyType() {
    const [propertyType, setPropertyType] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            propertyType: propertyType,
        };
        try {
            const res = await HomeService.addPropertyType(data);
            if (res?.status) {
                toast.success("Property type added successfully!");
                clearAddForm();
                navigate("/manage-property-type");
            }
        } catch (error) {
            toast.error("Failed to add property type.");
            console.error("Error adding property type:", error);
        }
    };

    const clearAddForm = () => {
        setPropertyType("");
    };

    return (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
            <div className="container-fluid">

                <div className="mt-5">
                    <div style={headLineStyle} className="page-headline">
                        Add Property Type
                    </div>
                    <hr />

                    <section className="chartBox_area">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 mt-3">
                                    <label htmlFor="propertyType">
                                        Property Type<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="propertyType"
                                        className="form-control"
                                        value={propertyType}
                                        onChange={(e) => setPropertyType(e.target.value)}
                                        placeholder="Enter Property Type"
                                        required
                                    />
                                </div>
                            </div>
                            <button
                                type="submit"
                                className="btn mt-3"
                                style={{
                                    background:'rgb(133, 218, 79)',
                                    borderRadius:'13px'
                                }}
                            >
                            
                                Add Property Type
                            </button>
                        </form>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default AddPropertyType;
